import styled from "styled-components";

export const SubjectsContainer = styled.div`
    margin: 60px auto 40px;
    max-width: 1200px;
    width: 100%;
    padding: 0 var(--container-pad);
    display: flex;
    flex-direction: column;
    gap: 36px;

    @media (max-width: 600px) {
        margin-top: 40px;
        gap: 28px;
    }
`;

export const SubjectWrapper = styled.div`
    display: grid;
    grid-template-columns: 440px 1fr;
    gap: 32px;
    align-items: center;
    background: white;
    padding: 24px;
    border-radius: var(--radius-xl);
    border: 1px solid var(--color-border);
    box-shadow: var(--shadow-sm);
    transition: var(--transition);

    &:hover {
        box-shadow: var(--shadow-md);
        border-color: var(--color-primary-light);
    }

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        gap: 22px;
    }

    @media (max-width: 600px) {
        padding: 18px;
    }
`;

export const SubjectWrapperContainer = styled.div``;

export const SubjectInfo = styled.p`
    font-size: 15px;
    line-height: 1.65;
    color: var(--color-text);
    margin: 0 0 12px;
`;

export const HeadText = styled.p`
    font-size: clamp(22px, 2.8vw, 28px);
    font-weight: 800;
    color: var(--color-primary);
    letter-spacing: -0.4px;
    margin: 0 0 16px;
    line-height: 1.2;
`;

export const SubjectImage = styled.img`
    width: 100%;
    aspect-ratio: 5 / 3;
    object-fit: cover;
    border-radius: var(--radius-lg);
`;
